<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn @on="on" @click.stop="toggleFavourite" icon>
        <v-icon
          :color="
            favourites.includes(layerId) ? 'yellow darken-3' : 'whitesmoke'
          "
          >{{ favourites.includes(layerId) ? "star" : "star_border" }}</v-icon
        >
      </v-btn>
    </template>
    <span>{{
      favourites.includes(layerId)
        ? "Fjern fra favoritter"
        : "Legg til som favoritt"
    }}</span>
  </v-tooltip>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "LayerFavouriteToggler",
  computed: {
    ...mapState(["favourites"])
  },
  props: {
    layerId: String
  },
  methods: {
    ...mapActions(["setSnack", "addFavourite", "removeFavourite"]),
    toggleFavourite(evt) {
      evt.stopPropagation();

      if (this.favourites.includes(this.layerId)) {
        this.removeFavourite(this.layerId);
      } else {
        this.addFavourite(this.layerId);
      }
    }
  }
};
</script>
